import { FC } from 'react';
import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';

interface AutocompleteFilterProps {
  label: string;
  value: any;
  setValue: (newVal: any) => void;
  valueOnly?: boolean;
  options: { id: string; name: string }[];
  multiple?: boolean;
}

export const AutocompleteFilter: FC<AutocompleteFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
  options,
  multiple,
}) => {
  const selectedValues = String(value)?.split(',') || [];

  if (valueOnly) {
    return (
      <>
        {selectedValues
          ?.map((v) => options?.find((s) => String(s.id) == v)?.name)
          ?.join(', ')}
      </>
    );
  }

  return (
    <Autocomplete
      size="small"
      multiple={multiple}
      value={
        multiple
          ? options?.filter((s) => selectedValues?.includes(String(s.id))) || []
          : options?.find((s) => selectedValues?.includes(String(s.id))) || null
      }
      onChange={(_, newValue) => {
        if (multiple) {
          setValue((newValue as any[]).map((v) => String(v.id)).join(','));
        } else {
          setValue(String(newValue?.id || ''));
        }
      }}
      options={options || []}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => {
        return <TextField {...params} label={label} size="small" />;
      }}
    />
  );
};
